/**
 * +UTILE Rent brand logo — uses the official raster asset provided by the user.
 * Do NOT restyle the image itself; render as-is on white/light surfaces.
 */
const LOGO_SRC =
  "https://customer-assets-agu9un31.emergentagent.net/job_fleet-marketplace-6/artifacts/msceedxy_ChatGPT%20Image%2015%20set%202026%2C%2017_14_59.png";

export default function Logo({ size = "md", className = "" }) {
  const heightMap = { sm: 44, md: 60, lg: 96 };
  const h = heightMap[size] || heightMap.md;
  return (
    <img
      src={LOGO_SRC}
      alt="+Utile Rent"
      draggable={false}
      className={`select-none block ${className}`}
      style={{ height: `${h}px`, width: "auto" }}
    />
  );
}
